export const gigSplOffers = [
    {
        "OfferId": "39887",
        "OfferText": "Samsung TV on us",
        "Price": 0,
        "Duration": 0,
        "IsSpecialOffer": "",
        "Target": "",
        "GroupId": "",
        "USOCIOSC": "R4420",
        "DataComp": "",
        "TvComp": "",
        "VoiceComp": "",
        "BsOfferAttr": "SPCLDISCOUNT",
        "BsOfferAttrValue": "FIOS_SAMSUNGTV_Q125_PROMO",
        "extendedAttributes": "LIFEONVERIZONHOME:YES,CARRYOVERONBAUMOVE:YES,REDEMPTIONELIGIBLEDAYS:65, REDEMPTIONREMINDER:95_118,REDEMPTIONEXPIRYDAYS:125,REDEMPTIONREGISTRATIONREQD:NO,REDEMPTIONBALANCECHECK:Yes,FCONLYDATACOMPCARRYOVER,OFFERCLOSEOUTDATE:10022025,CHATBOT:YES,NOTTOQUALIFYONSEAMLESSMOVE,SMARTCART:YES,SMARTCARTOVERRIDE:YES,TILEDISPLAY:YES,ISCHOICE:YES,PCODE:0",
        "Rank": "1",
        "bsOfferId": "OF10043499",
        "exclusionList": "39890,",
        "allOffers": "",
        "isMoversOffers": "",
        "offerType": "",
        "bsPromoId": "PR10009312",
        "offerFor": "Data",
        "additionalProperties": {
            "TARGETTYPE": "BUNDLE_STANDALONE",
            "BUNDLE_IDS": "B0001,B0002,B0003,B0005,B0010,B0014,B0015,B0038,B0039"
        }
    },
    {
        "OfferId": "39890",
        "OfferText": "Meta Quest 3S headset - 128GB",
        "Price": 0,
        "Duration": 0,
        "IsSpecialOffer": "",
        "Target": "",
        "GroupId": "",
        "USOCIOSC": "R4421",
        "DataComp": "",
        "TvComp": "",
        "VoiceComp": "",
        "BsOfferAttr": "SPCLDISCOUNT",
        "BsOfferAttrValue": "FIOS_META_QUEST_3S_HEADSET_Q125_PROMO",
        "extendedAttributes": "LIFEONVERIZONHOME:YES,REDEMPTIONELIGIBLEDAYS:65,REDEMPTIONREMINDER:95_118,REDEMPTIONEXPIRYDAYS:125,REDEMPTIONREGISTRATIONREQD:Yes,REDEMPTIONBALANCECHECK:No,FCONLYDATACOMPCARRYOVER,CARRYOVERONBAUMOVE:YES,CHATBOT:YES,SHOWOFFERMESSAGEONLOAD:YES,OFFERCLOSEOUTDATE:10022025,SMARTCART:YES,SMARTCARTOVERRIDE:YES,TILEDISPLAY:YES,ISCHOICE:YES,PCODE:0",
        "Rank": "2",
        "bsOfferId": "OF10043500",
        "exclusionList": "39887,",
        "allOffers": "",
        "isMoversOffers": "",
        "offerType": "",
        "bsPromoId": "PR10009313",
        "offerFor": "Data",
        "additionalProperties": {
            "TARGETTYPE": "BUNDLE_STANDALONE",
            "BUNDLE_IDS": "B0001,B0002,B0003,B0005,B0010,B0014,B0015,B0038,B0039"
        }
    }
]

export const splOffersAPIRes = {
    "meta": {
        "code": 200,
        "description": "Calling Product Product-getSpecialOffers",
        "timestamp": "Mon Apr 14 11:03:52 UTC 2025"
    },
    "data": {
        "offersMTM": [
            {
                "OfferId": "39887",
                "OfferText": "Samsung TV on us",
                "Price": 0,
                "Duration": 0,
                "IsSpecialOffer": "",
                "Target": "",
                "GroupId": "",
                "USOCIOSC": "R4420",
                "DataComp": "",
                "TvComp": "",
                "VoiceComp": "",
                "BsOfferAttr": "SPCLDISCOUNT",
                "BsOfferAttrValue": "FIOS_SAMSUNGTV_Q125_PROMO",
                "extendedAttributes": "LIFEONVERIZONHOME:YES,CARRYOVERONBAUMOVE:YES,REDEMPTIONELIGIBLEDAYS:65, REDEMPTIONREMINDER:95_118,REDEMPTIONEXPIRYDAYS:125,REDEMPTIONREGISTRATIONREQD:NO,REDEMPTIONBALANCECHECK:Yes,FCONLYDATACOMPCARRYOVER,OFFERCLOSEOUTDATE:10022025,CHATBOT:YES,NOTTOQUALIFYONSEAMLESSMOVE,SMARTCART:YES,SMARTCARTOVERRIDE:YES,TILEDISPLAY:YES,ISCHOICE:YES,PCODE:0",
                "Rank": "1",
                "bsOfferId": "OF10043499",
                "exclusionList": "39890,",
                "allOffers": "",
                "isMoversOffers": "",
                "offerType": "",
                "bsPromoId": "PR10009312",
                "offerFor": "Data",
                "additionalProperties": {
                    "TARGETTYPE": "BUNDLE_STANDALONE",
                    "BUNDLE_IDS": "B0001,B0002,B0003,B0005,B0010,B0014,B0015,B0038,B0039"
                }
            },
            {
                "OfferId": "39890",
                "OfferText": "Meta Quest 3S headset - 128GB",
                "Price": 0,
                "Duration": 0,
                "IsSpecialOffer": "",
                "Target": "",
                "GroupId": "",
                "USOCIOSC": "R4421",
                "DataComp": "",
                "TvComp": "",
                "VoiceComp": "",
                "BsOfferAttr": "SPCLDISCOUNT",
                "BsOfferAttrValue": "FIOS_META_QUEST_3S_HEADSET_Q125_PROMO",
                "extendedAttributes": "LIFEONVERIZONHOME:YES,REDEMPTIONELIGIBLEDAYS:65,REDEMPTIONREMINDER:95_118,REDEMPTIONEXPIRYDAYS:125,REDEMPTIONREGISTRATIONREQD:Yes,REDEMPTIONBALANCECHECK:No,FCONLYDATACOMPCARRYOVER,CARRYOVERONBAUMOVE:YES,CHATBOT:YES,SHOWOFFERMESSAGEONLOAD:YES,OFFERCLOSEOUTDATE:10022025,SMARTCART:YES,SMARTCARTOVERRIDE:YES,TILEDISPLAY:YES,ISCHOICE:YES,PCODE:0",
                "Rank": "2",
                "bsOfferId": "OF10043500",
                "exclusionList": "39887,",
                "allOffers": "",
                "isMoversOffers": "",
                "offerType": "",
                "bsPromoId": "PR10009313",
                "offerFor": "Data",
                "additionalProperties": {
                    "TARGETTYPE": "BUNDLE_STANDALONE",
                    "BUNDLE_IDS": "B0001,B0002,B0003,B0005,B0010,B0014,B0015,B0038,B0039"
                }
            },
            {
                "OfferId": "39163",
                "OfferText": "$100 Verizon Gift Card",
                "Price": 0,
                "Duration": 0,
                "IsSpecialOffer": "",
                "Target": "",
                "GroupId": "",
                "USOCIOSC": "R2543",
                "DataComp": "",
                "TvComp": "",
                "VoiceComp": "",
                "BsOfferAttr": "VZREWARD",
                "BsOfferAttrValue": "$100_VERIZON_GC_DISCOUNT_NDMA",
                "extendedAttributes": "LIFEONVERIZONHOME:YES,CARRYOVERONBAUMOVE:NO,REDEMPTIONELIGIBLEDAYS:65,REDEMPTIONREMINDER:95_118,REDEMPTIONEXPIRYDAYS:125,REDEMPTIONREGISTRATIONREQD:NO,REDEMPTIONBALANCECHECK:Yes,CHATBOT:YES,NOTQUALIFYONSEAMLESSMOVE,SMARTCART:YES,SMARTCARTOVERRIDE:YES,OFFERCLOSEOUTDATE:09022025,TILEDISPLAY:YES,PCODE:0",
                "Rank": "3",
                "bsOfferId": "OF10042561",
                "exclusionList": "5135,5137,5138,5140,5143,5541,",
                "allOffers": "",
                "isMoversOffers": "",
                "offerType": "",
                "bsPromoId": "PR10008754",
                "offerFor": "Data",
                "additionalProperties": {
                    "TARGETTYPE": "BUNDLE_STANDALONE",
                    "BUNDLE_IDS": "B0003,B0005,B0010,B0014,B0015,B0038"
                }
            },
            {
                "OfferId": "39177",
                "OfferText": "Fios Setup Discount",
                "Price": 0,
                "Duration": 0,
                "IsSpecialOffer": "",
                "Target": "N9056,O7533,P4666,P7776,Q2138",
                "GroupId": "",
                "USOCIOSC": "P0256",
                "DataComp": "",
                "TvComp": "",
                "VoiceComp": "",
                "BsOfferAttr": "NRCWAIVER",
                "BsOfferAttrValue": "SETUPFEE",
                "extendedAttributes": "SMARTCART:YES,SUPPRESS50%ONSMARTCART,RateTypeValue:NRC,PCODE:1",
                "Rank": "154",
                "bsOfferId": "OF10029776",
                "exclusionList": "39179,39180,39181,39182,39218,39219,39220,",
                "allOffers": "",
                "isMoversOffers": "",
                "offerType": "",
                "bsPromoId": "PR10008778",
                "offerFor": "Data",
                "additionalProperties": {
                    "TARGETTYPE": "BUNDLE_STANDALONE",
                    "BUNDLE_IDS": "B0038,B0039"
                }
            }
        ]
    }
}